// @flow
import { connect } from 'react-redux';

import CompetitionsInternationalesMatchHeader from 'components/competitionsInternationales/CompetitionsInternationalesMatchHeader';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/competitionsInternationales/CompetitionsInternationalesMatchHeader';

export default connect((state: StateType): StateProps => ({
  data: state.competitionsInternationalesState.data,
  rencontre: state.rencontreState.rencontre,
  status: state.rencontreState.status
}))(CompetitionsInternationalesMatchHeader);
